(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zorro-global-sale-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const bars = document.querySelectorAll('[data-zsale-bar]:not([data-zsale-ready])');
    if (!bars.length) return;

    const helsinkiClock = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Helsinki',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    const flashSecondsRemaining = (date) => {
      const parts = Object.fromEntries(
        helsinkiClock
          .formatToParts(date)
          .filter((part) => part.type !== 'literal')
          .map((part) => [part.type, Number(part.value)])
      );
      const secondsIntoDay = parts.hour * 3600 + parts.minute * 60 + parts.second;
      return 10800 - (secondsIntoDay % 10800);
    };

    const formatClock = (totalSeconds) => {
      const seconds = Math.max(0, Math.ceil(totalSeconds));
      const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor(seconds / 60) % 60).padStart(2, '0');
      const remainder = String(seconds % 60).padStart(2, '0');
      return { hours, minutes, seconds: remainder };
    };

    bars.forEach((bar) => {
      bar.setAttribute('data-zsale-ready', '');
      const message = bar.querySelector('[data-zsale-message]');
      const clock = bar.querySelector('[data-zsale-clock]');
      const hours = bar.querySelector('[data-zsale-hours]');
      const minutes = bar.querySelector('[data-zsale-minutes]');
      const seconds = bar.querySelector('[data-zsale-seconds]');
      const dropStart = Date.parse(bar.dataset.dropStart);
      const dropEnd = Date.parse(bar.dataset.dropEnd);

      const update = () => {
        const now = Date.now();
        const dropIsLive = now >= dropStart && now < dropEnd;
        const remaining = dropIsLive
          ? (dropEnd - now) / 1000
          : flashSecondsRemaining(new Date(now));
        const label = dropIsLive ? message.dataset.dropLabel : message.dataset.flashLabel;

        bar.classList.toggle('is-drop-live', dropIsLive);
        bar.setAttribute('aria-label', label);
        message.textContent = label;
        const clockParts = formatClock(remaining);
        hours.textContent = clockParts.hours;
        minutes.textContent = clockParts.minutes;
        seconds.textContent = clockParts.seconds;
        clock.setAttribute('datetime', `PT${Math.max(0, Math.ceil(remaining))}S`);
      };

      update();
      window.setInterval(update, 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
